import axios from "axios";
import { toast } from "react-hot-toast";

const apiConfig = (setLoading) => {
  const logoutErrorCodes = [401, 403];

  const BASE_URL =
    "https://n2ski6np08.execute-api.ap-south-1.amazonaws.com/api";

  axios.defaults.baseURL = BASE_URL;

  axios.interceptors.request.use(
    (config) => {
      if (setLoading) setLoading(true);
      return config;
    },
    (error) => {
      if (setLoading) setLoading(false);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (setLoading) setLoading(false);
      return response;
    },
    (error) => {
      if (setLoading) setLoading(false);
      if (error.response && logoutErrorCodes.includes(error.response.status)) {
        localStorage.clear();
        toast.error("Session timed out. Please log in again.");
        setTimeout(() => {
          window.location.href = "/auth/login";
        }, 1500);
      }
      return Promise.reject(error);
    }
  );
};

export default apiConfig;
